
const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/554888397243?text=Olá vim do site e gostaria de atendimento', '_blank');
  };

  return (
    <footer className="bg-[#0D0D0D] border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        {/* Logo e Slogan */}
        <div className="text-center mb-8">
          <img 
            src="https://static.readdy.ai/image/23e6e82711d555609e11a3dec8506ccb/b56242dfe0d6ad4740b3bcc4ba25f998.png" 
            alt="Aura Estética Automotiva" 
            className="h-16 w-auto mx-auto mb-4"
          />
          <p className="text-[#C8A45D] text-lg font-light italic">
            "Detalhes refinados para uma experiência superior."
          </p>
        </div>

        {/* Menu Rápido */}
        <div className="flex flex-wrap justify-center items-center gap-8 mb-8">
          <button 
            onClick={() => scrollToSection('home')}
            className="text-gray-300 hover:text-[#C8A45D] transition-colors duration-300 font-medium"
          >
            Home
          </button>
          <button 
            onClick={() => scrollToSection('services')}
            className="text-gray-300 hover:text-[#C8A45D] transition-colors duration-300 font-medium"
          >
            Serviços
          </button>
          <button 
            onClick={() => scrollToSection('gallery')}
            className="text-gray-300 hover:text-[#C8A45D] transition-colors duration-300 font-medium"
          >
            Galeria
          </button>
          <button 
            onClick={() => scrollToSection('contact')}
            className="text-gray-300 hover:text-[#C8A45D] transition-colors duration-300 font-medium"
          >
            Contato
          </button>
        </div>

        {/* Redes Sociais */}
        <div className="flex justify-center items-center gap-6 mb-8">
          <a 
            href="https://www.instagram.com/auraesteticaautomotiva" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-12 h-12 flex items-center justify-center bg-gray-800 hover:bg-[#C8A45D] text-white hover:text-black rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#C8A45D]/20"
          >
            <i className="ri-instagram-line text-xl"></i>
          </a>
          <button 
            onClick={handleWhatsApp}
            className="w-12 h-12 flex items-center justify-center bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#25D366]/20"
          >
            <i className="ri-whatsapp-line text-xl"></i>
          </button>
        </div>

        {/* Informações de Contato */}
        <div className="text-center mb-8">
          <div className="flex flex-wrap justify-center items-center gap-8 text-gray-300">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-[#C8A45D]"></i>
              <span>(48) 8839-7243</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-[#C8A45D]"></i>
              <span>Florianópolis - SC</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-[#C8A45D]"></i>
              <span>Segunda a Sexta: 8h às 18h</span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm mb-2">
            © 2025 Aura Estética Automotiva — Todos os direitos reservados.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-[#C8A45D] text-xs transition-colors duration-300"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
